// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cjhzS","largestCol":"styles_largestCol__3mJHT","smallestCol":"styles_smallestCol__1II5h"};